import {useEffect} from "react";
import {useForm, Controller} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import * as Yup from "yup";
import {ModalForm} from "~/components";
import {InputField, TextAreaField} from "~/components/Forms";

const schema = Yup.object().shape({
	keywords: Yup.string().trim().required('Vui lòng nhập ít nhất 1 từ khoá'),
});

/**
 * Modal thêm từ khoá thủ công vào Kho — ModalForm + react-hook-form (chuẩn form dự án).
 * Nhập nhiều từ khoá, mỗi dòng một từ; ghi chú (tuỳ chọn) áp cho cả loạt.
 */
function KeywordAddModal({open, submitting, onCancel, onSubmit}) {

	const {control, handleSubmit, reset, formState: {errors}} = useForm({
		defaultValues: {keywords: '', note: ''},
		resolver: yupResolver(schema),
	});

	useEffect(() => {
		if (open) reset({keywords: '', note: ''});
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [open]);

	return (
		<ModalForm
			open={open}
			icon="fa-light fa-tags"
			title="Thêm từ khoá vào kho"
			subtitle="Mỗi dòng một từ khoá — trùng với kho sẽ tự bỏ qua"
			onCancel={onCancel}
			onOk={handleSubmit(onSubmit)}
			okText="Lưu vào kho"
			loading={submitting}
		>
			<Controller control={control} name="keywords" render={({field}) => (
				<TextAreaField label="Danh sách từ khoá" rows={6}
					placeholder={"dịch vụ seo tphcm\nkhóa học seo cơ bản\n..."} errors={errors} {...field} />
			)} />
			<Controller control={control} name="note" render={({field}) => (
				<InputField label="Ghi chú (tuỳ chọn)" placeholder="VD: nhóm chủ đề dịch vụ" errors={errors} {...field} />
			)} />
		</ModalForm>
	);
}

export default KeywordAddModal;
